import { c as _c } from "react/compiler-runtime";
import { useState, useCallback, useEffect } from "react";

/**
 * Shared state for LiveMetricsIndicator sheet across components.
 * Uses module-level state to allow multiple components to control
 * the same sheet instance (e.g., StatusIndicator can open it).
 */
let sharedOpenState = false;
let listeners: Set<(open: boolean) => void> = new Set();
const notifyListeners = (open: boolean) => {
  sharedOpenState = open;
  listeners.forEach(listener => listener(open));
};

/**
 * Hook to manage LiveMetricsIndicator sheet state.
 * Multiple components can use this hook to control the same sheet instance.
 *
 * @returns Object with sheet state and control functions
 */
export const useLiveMetricsSheetState = () => {
  const $ = _c(4);
  const [isOpen, setIsOpen] = useState(sharedOpenState);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const listener = open => setIsOpen(open);
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  const setOpen = _temp;
  const openLiveMetricsSheet = _temp2;
  const closeLiveMetricsSheet = _temp3;
  let t2;
  if ($[2] !== isOpen) {
    t2 = {
      isOpen,
      setIsOpen: setOpen,
      openLiveMetricsSheet,
      closeLiveMetricsSheet
    };
    $[2] = isOpen;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
function _temp(open_0) {
  notifyListeners(open_0);
}
function _temp2() {
  notifyListeners(true);
}
function _temp3() {
  notifyListeners(false);
}